import styles from './IdentityVerification.module.css';
import success from '../../../assets/pages/addProperty/identity-verification/success.svg';
import visa from '../../../assets/pages/payment/visa.png';
import mastercard from '../../../assets/pages/payment/mastercard.png';
import crypto from '../../../assets/pages/payment/crypto.png';
import interac from '../../../assets/pages/payment/interac.svg';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Check } from 'lucide-react';
import { useModal } from '../../hooks/modalContext';
import { useAuth } from '../../../auth/Auth';
import { pushStorage } from '../../webPush/pushNotificationStorage';

const PAYMENT_CONFIRMED_STEPS = [
  { label: 'Payment authorized', status: 'Done' as const },
  { label: 'Identity verified', status: 'Done' as const },
  { label: 'Sending to your landlord', status: 'In progress' as const },
];

const IDVSuccess = () => {
  const navigate = useNavigate();
  const { setModal, modalState } = useModal();
  const { currentUser } = useAuth();
  const userId = currentUser?.user?.userId;
  const pendingIdvAuthHold = modalState?.pendingIdvAuthHold === true;

  useEffect(() => {
    if (userId != null) {
      pushStorage.setHasCompletedIdv(userId);
    }
  }, [userId]);

  const handleDone = () => {
    if (userId != null) {
      pushStorage.setHasCompletedIdv(userId);
    }
    navigate('/dashboard');
    setModal(null, { refreshProfile: true });
  };

  const handlePayLater = () => {
    if (userId != null) {
      pushStorage.setHasCompletedIdv(userId);
    }
    navigate('/dashboard');
    setModal(null, { refreshProfile: true });
  };

  const handlePayNow = () => {
    if (userId != null) {
      pushStorage.setHasCompletedIdv(userId);
    }
    navigate('/pay-rent');
    setModal(null, { refreshProfile: true });
  };

  if (pendingIdvAuthHold) {
    return (
      <motion.main
        className={`${styles.main} ${styles.centeredMain}`}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <img src={success} alt='success' className={`${styles.img} ${styles.successImg}`} />
        <p className={styles.successText}>You're all set</p>
        <p className={styles.successPara}>
          Identity verified. Your rent payment is confirmed and now processing. Nothing more to do.
        </p>

        <div className='mt-6 flex w-full flex-col gap-5 rounded-[20px] bg-[rgba(33,81,236,0.06)] px-6 py-8'>
          <ul className='flex w-full flex-col gap-3'>
            {PAYMENT_CONFIRMED_STEPS.map((step, index) => {
              const isDone = step.status === 'Done';
              return (
                <li key={step.label} className='flex items-center justify-between gap-3'>
                  <div className='flex items-center gap-2.5'>
                    <span
                      className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-[11px] font-bold ${
                        isDone
                          ? 'bg-success text-white'
                          : 'border-2 border-primary bg-white text-primary'
                      }`}
                    >
                      {isDone ? <Check className='h-3.5 w-3.5' strokeWidth={3} /> : index + 1}
                    </span>
                    <span
                      className={`text-sm font-medium ${
                        isDone ? 'text-main' : 'text-primary font-semibold'
                      }`}
                    >
                      {step.label}
                    </span>
                  </div>
                  <span
                    className={`text-xs font-semibold ${isDone ? 'text-success' : 'text-primary'}`}
                  >
                    {step.status}
                  </span>
                </li>
              );
            })}
          </ul>

          <span className='text-main text-sm'>
            We'll email you as soon as your rent is on its way to your landlord. You don't need to
            pay again.
          </span>

          <button className='submitBtn w-full' onClick={handleDone}>
            <div className='flex w-full justify-between px-6'>
              <span className='font-semibold'>Done</span>
              <ArrowRight className='h-5 w-5 text-white' />
            </div>
          </button>

          <span className='text-main text-center text-sm'>
            Payment reference will appear in your rent history.
          </span>
        </div>
      </motion.main>
    );
  }

  return (
    <motion.main
      className={`${styles.main} ${styles.centeredMain}`}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <img src={success} alt='success' className={`${styles.img} ${styles.successImg}`} />
      <p className={styles.successText}>Verification completed!</p>

      <p className={styles.successPara}>
        You’re all set! Identity verified, now kick back and choose your way to make rent,
        hassle-free and smooth as ever. 🎉💸
      </p>
      <div className={styles.iconsWrap}>
        <img src={visa} alt='payment-img' className={styles.paymentImg} />
        <img src={mastercard} alt='payment-img' className={styles.paymentImg} />
        <img src={crypto} alt='payment-img' className={styles.paymentImg} />
        <img src={interac} alt='payment-img' className={styles.paymentImg} />
      </div>
      <div className={styles.buttonsWrap}>
        <button
          className={`cancelBtn ${styles.successBtn}`}
          onClick={handlePayLater}
        >
          {'Pay later'}
        </button>
        <button
          className={`submitBtn ${styles.successBtn}`}
          onClick={handlePayNow}
        >
          {'Pay manually'}
        </button>
      </div>
    </motion.main>
  );
};
export default IDVSuccess;
